export default "__VITE_ASSET__Bqq3anuO__"